import { render, staticRenderFns } from "./CardMonitoring.vue?vue&type=template&id=404f50cd&scoped=true"
import script from "./CardMonitoring.vue?vue&type=script&lang=js"
export * from "./CardMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404f50cd",
  null
  
)

export default component.exports